module.exports = __webpack_public_path__ + "img/sh.sh1727921.svg";